import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';

export default selectors;
export { reducer, actions, selectors };
